export const API_BASE_URL = process.env.VUE_APP_BASE_URL || ''
export const ASSET_BASE_URL = process.env.VUE_APP_ASSET_URL || 'https://used.one.shuzidianli.cn'
export const THEME_COLOR = '#FFE60F'
